import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { NameInitialsAvatar } from "react-name-initials-avatar";

const Sidebar = () => {
  const [menu, setMenu] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [brokenImages, setBrokenImages] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  // Sidebar open/close state check karne ke liye (Optional: CSS classes handles it mostly)
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem("token")) {
        let user = jwt_decode(sessionStorage.getItem("token"));
        setUserInfo(user);
        if (user.userrole !== "SYS_ADMIN") {
          const subscriptionEndDate = new Date(user.subscription.end_date);
          const currentDate = new Date();
          if (subscriptionEndDate <= currentDate) {
            navigate("/402");
          }
        }
        setMenu(user.modules);
      }
    } catch (error) {
      console.log(error);
    }
  }, [navigate]);

  const navigatePage = (destination, defaultHide) => {
    if (isMobile || defaultHide) hideSideBar();
    setTimeout(() => {
      navigate(destination);
    }, 100);
  };

  const hideSideBar = () => {
    const sidebar = document.querySelector("#sidebar");
    sidebar.classList.toggle("hide");
    sidebar.classList.toggle("show");
    setIsCollapsed(sidebar.classList.contains("hide"));
  };

  const profileImage =
    userInfo?.tenantcode && `/public/${userInfo.tenantcode}/users`;
  const sidebarImgKey = userInfo?.id ? `sidebar-img-${userInfo.id}` : "";
  const showProfilePhoto =
    profileImage && userInfo?.id && !brokenImages.includes(sidebarImgKey);

  const renderMenuItems = () => {
    if (userInfo.userrole !== "SYS_ADMIN") {
      const filteredMenu = menu.filter(
        (menuItem) => menuItem.parent_module === null,
      );
      const sortedMenu = filteredMenu.sort((a, b) => a.order_no - b.order_no);

      return sortedMenu.map((menuItem) => (
        <li
          key={menuItem.id}
          className={location.pathname.includes(menuItem.url) ? "active" : ""}
        >
          <span
            style={{ cursor: "pointer" }}
            className="custom-link-sidebar"
            title={menuItem.name}
            onClick={() => navigatePage(`/${menuItem.url}`, false)}
          >
            <i className={`${menuItem.icon} mx-2`}></i>
            <span className="menu-text">{menuItem.name}</span>
          </span>
        </li>
      ));
    }
    return null;
  };

  return (
    <>
      <nav id="sidebar" className={isMobile ? "hide" : "show"}>
        <div>
          <div className="sidebar-header text-center">
            <div
            // style={{
            //   backgroundColor: "#fff",
            //   padding: "5px",
            //   borderRadius: "10px",
            //   boxShadow: "rgba(0, 0, 0, 0.18) 0px 2px 4px",
            // }}
            >
              <img
                src={"https://admin.watconnect.com/fav.png"}
                className={isCollapsed ? "logo-mini" : "logo-full"}
                style={{
                  width: isCollapsed ? "40px" : "130px", // Inline width backup
                  height: "auto",
                  transition: "all 0.3s ease", // Smooth transition
                  margin: "0 auto",
                  display: "block",
                }}
                alt="Logo"
              />
              <h4
                style={{
                  color: "var(--text-color-2)",
                }}
                className="logo-text"
              >
                WatConnect
              </h4>
            </div>
          </div>

          <ul
            className="list-unstyled components"
            style={{
              borderTop: "1px solid var(--bs-border-color, #d5e3dc)",
            }}
          >
            <li className={`${location.pathname === "/" ? "active" : ""}`}>
              <span
                className="custom-link-sidebar"
                onClick={(e) => navigatePage("/", false)}
              >
                <i className="fa-solid fa-house mx-2"></i>
                <span className="menu-text">Home</span>
              </span>
            </li>

            {userInfo.userrole === "SYS_ADMIN" && (
              <>
                <li
                  className={
                    location.pathname.includes("/module") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/module", false)}
                  >
                    <i className="fa fa-bars mx-2"></i>
                    <span className="menu-text">Module</span>
                  </span>
                </li>
                <li
                  className={
                    location.pathname.includes("/plan") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/plan", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">Plan</span>
                  </span>
                </li>
                <li
                  className={
                    location.pathname.includes("/addon") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/addon", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">Addon</span>
                  </span>
                </li>
                <li
                  className={
                    location.pathname.includes("/company") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/company", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">Company</span>
                  </span>
                </li>
                <li
                  className={
                    location.pathname.includes("/invoice") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/invoice", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">Invoice</span>
                  </span>
                </li>
                <li
                  className={
                    location.pathname.includes("/wallet") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/wallet", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">Wallet</span>
                  </span>
                </li>

                <li
                  className={
                    location.pathname.includes("/wabas") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/wabas", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">All Wabas</span>
                  </span>
                </li>
                <li
                  className={
                    location.pathname.includes("/waba_settings") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/waba_settings", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">All Settings</span>
                  </span>
                </li>
                <li
                  className={
                    location.pathname.includes("/users") ? "active" : ""
                  }
                >
                  <span
                    className="custom-link-sidebar"
                    onClick={() => navigatePage("/users", false)}
                  >
                    <i className="fa-solid fa-money-check mx-2"></i>
                    <span className="menu-text">Users</span>
                  </span>
                </li>
              </>
            )}

            {renderMenuItems()}

            {(userInfo.userrole === "ADMIN" || userInfo.userrole === "SYS_ADMIN") && (
              <li
                className={
                  location.pathname.includes("/storage_management") ? "active" : ""
                }
              >
                <span
                  className="custom-link-sidebar"
                  onClick={() => navigatePage("/storage_management", false)}
                >
                  <i className="fa-solid fa-database mx-2"></i>
                  <span className="menu-text">Storage Cleanup</span>
                </span>
              </li>
            )}

            <li
              className={
                location.pathname.includes("/myprofile") ? "active" : ""
              }
            >
              <span
                className="custom-link-sidebar"
                onClick={() => navigatePage("/myprofile", false)}
              >
                <i className="fa fa-user-circle mx-2"></i>
                <span className="menu-text">My Profile</span>
              </span>
            </li>
          </ul>
          <div className="sidebar-user">
            <div className="user-img">
              {showProfilePhoto ? (
                <img
                  src={`${profileImage}/${userInfo.id}`}
                  alt=""
                  onError={() =>
                    setBrokenImages((prev) => [...prev, sidebarImgKey])
                  }
                />
              ) : (
                <NameInitialsAvatar
                  size="50px"
                  textSize="18px"
                  bgColor="#49C858"
                  borderWidth="0px"
                  textColor="#fff"
                  name={userInfo?.username || "User"}
                />
              )}
            </div>

            <div className="user-info">
              <p className="user-name">{userInfo?.username || "User Name"}</p>
              <p className="user-role">{userInfo?.userrole || "Role"}</p>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
